import styles from '../css/HorizontalMenu.module.scss';

const hideInactiveHorizontalLines = (refs) => {
    const { newRelease, popular } = refs;
    newRelease.classList.add(styles.horizontal__menu__container__hide);
    return popular.classList.add(styles.horizontal__menu__container__hide);
};

export default hideInactiveHorizontalLines;
